import { LogoutIcon } from "@heroicons/react/outline";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { useForm } from "react-hook-form";
import axiosInstance from "../../../Service/Interceptor";

export default function PrivacyPassword() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onFormSubmit = (data) => {
    axiosInstance
      .post(`users/api/v1/users/settings/change-password/`, data)
      .then((res) => {
        toast.success(`${res.data.message}`, {
          position: "top-right",
          autoClose: 1000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setTimeout(() => {
          window.location.reload();
        }, 1200);
      })
      .catch((err) => {
        if (err.response.data.message) {
          toast.error(`${err.response.data.message}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (err.response.data.new_password) {
          toast.error(`${err.response.data.new_password}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (err.response.data.confirm_new_password) {
          toast.error(`${err.response.data.confirm_new_password}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (
          err.response.data.new_password &&
          err.response.data.confirm_new_password
        ) {
          toast.error(`${err.response.data.new_password}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        } else if (err.response.data.non_field_errors) {
          toast.error(`${err.response.data.non_field_errors}`, {
            position: "top-right",
            autoClose: 1000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      });
  };
  return (
    <>
      <section className="relative">
        <div className="w-full rounded-lg  drop-shadow-[0px_8px_2px_rgba(44,141,255,0.29)] py-10 px-4 space-y-2">
          <div className="grid  grid-cols-12">
           

            <div className="col-span-12 h-full w-full bg-white my-5 px-3 py-3  border-dotted border-[2px] border-gray-300">
              <form onSubmit={handleSubmit(onFormSubmit)}>
                <div className="mb-4">
                  <label className="text-gray-400 font-normal text-sm ">
                    Existing Password
                  </label>
                  <div className="flex mt-1">
                    <input
                      className="border rounded w-full py-2 px-3 text-[#282828] leading-tight focus:outline-none focus:shadow-outline"
                      name="old_password"
                      type="password"
                      placeholder="Enter existing password"
                      {...register("old_password", { required: true })}
                    />
                  </div>

                  {errors.old_password &&
                    errors.old_password.type === "required" && (
                      <span className="text-xs font-semibold text-red-400 text-left">
                        existing password is required
                      </span>
                    )}
                </div>
                <div className="mb-4">
                  <label className="text-gray-400 font-normal text-sm ">
                    New Password
                  </label>
                  <div className="flex mt-1">
                    <input
                      className="border rounded w-full py-2 px-3 text-[#282828] leading-tight focus:outline-none focus:shadow-outline"
                      name="new_password"
                      type="password"
                      placeholder="Enter new password"
                      {...register("new_password", { required: true })}
                    />
                  </div>

                  {errors.new_password &&
                    errors.new_password.type === "required" && (
                      <span className="text-xs font-semibold text-red-400 text-left">
                        new password is required
                      </span>
                    )}
                </div>
                <div className="mb-4">
                  <label className="text-gray-400 font-normal text-sm ">
                    Re-type new Password
                  </label>
                  <div className="flex mt-1">
                    <input
                      className="border rounded w-full py-2 px-3 text-[#282828] leading-tight focus:outline-none focus:shadow-outline"
                      name="confirm_new_password"
                      type="password"
                      placeholder="Enter re-type new password"
                      {...register("confirm_new_password", { required: true })}
                    />
                  </div>

                  {errors.confirm_new_password &&
                    errors.confirm_new_password.type === "required" && (
                      <span className="text-xs font-semibold text-red-400 text-left">
                        re-type new password is required
                      </span>
                    )}
                </div>

                <div className="flex justify-end">
                  <button className="mr-2 px-5 py-2  bg-gray-400 rounded-lg text-white cursor-pointer">
                    Cancel
                  </button>

                  <button
                    className="ml-2 px-2 py-2  bg-[#3076CE] rounded-lg text-white cursor-pointer"
                    type="submit"
                  >
                    Reset Password
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      <ToastContainer />
    </>
  );
}
